import type { StaticLayoutProps } from "./static-layout.type";

import { Layout } from "antd";
import classNames from "classnames";

import { AppLogo } from "@/ui/app-logo";

import { StaticLayoutCarousel } from "./static-layout-carousel";
import { useStaticLayoutSiderWidth } from "./static-layout.hook";

import "./static-layout.style.less";

const { Header, Footer, Content, Sider } = Layout;

export const StaticLayout = ({
  content,
  header,
  footer,
  slides,
  className,
}: StaticLayoutProps) => {
  const siderWidth = useStaticLayoutSiderWidth();

  return (
    <Layout className={classNames("static-layout", className)}>
      {siderWidth && (
        <Sider width={siderWidth} className="static-layout-sider">
          <StaticLayoutCarousel slides={slides} />
        </Sider>
      )}
      <Layout className="static-layout-main">
        <Header className="static-layout-header">
          <AppLogo />
          {header}
        </Header>
        <Content className="static-layout-content">{content}</Content>
        {footer ? (
          <Footer className="static-layout-footer">{footer}</Footer>
        ) : null}
      </Layout>
    </Layout>
  );
};
